import { takeEvery, put, all, call, fork } from "redux-saga/effects";
import {
  REQUEST_PASSWORD_RESET,
  VERIFY_MFA_CODE,
  RESET_PASSWORD,
} from "./actionTypes";
import {
  requestPasswordResetSuccess,
  requestPasswordResetError,
  verifyMFASuccess,
  verifyMFAError,
  resetPasswordSuccess,
  resetPasswordError,
} from "./actions";
import { postRequestPasswordReset, postVerifyMFA, postResetPassword } from "../../../helpers/fakebackend_helper";

// Step 1: Request Password Reset
function* requestPasswordReset({ payload: { email } }) {
  try {
    const response = yield call(postRequestPasswordReset, { email });
    if (response && response.success) {
      yield put(requestPasswordResetSuccess("MFA code sent to your email."));
    }
  } catch (error) {
    yield put(requestPasswordResetError("Failed to send MFA code."));
  }
}

// Step 2: Verify MFA Code
function* verifyMFACode({ payload: { email, code } }) {
  try {
    const response = yield call(postVerifyMFA, { email, code });
    if (response && response.success) {
      yield put(verifyMFASuccess("MFA code verified successfully."));
    }
  } catch (error) {
    yield put(verifyMFAError("Invalid MFA code."));
  }
}

// Step 3: Reset Password
function* resetPassword({ payload: { email, newPassword } }) {
  console.log(email, newPassword);
  try {
    const response = yield call(postResetPassword, { email, newPassword });
    if (response && response.success) {
      yield put(resetPasswordSuccess("Password reset successful."));
    }
  } catch (error) {
    yield put(resetPasswordError("Failed to reset password."));
  }
}

// Watchers
function* watchRequestPasswordReset() {
  yield takeEvery(REQUEST_PASSWORD_RESET, requestPasswordReset);
}

function* watchVerifyMFACode() {
  yield takeEvery(VERIFY_MFA_CODE, verifyMFACode);
}

function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

export default function* forgetPasswordSaga() {
  yield all([
    fork(watchRequestPasswordReset),
    fork(watchVerifyMFACode),
    fork(watchResetPassword),
  ]);
}
